import '../../components/table-control/table-control'
import GenericListSearchTabDxGrid from "../../factories/generic-list-search-tab-dxgrid";

/**
 * LabelConfigurationItemFilter ViewModel class
 */
class LabelConfigurationItemFilter extends GenericListSearchTabDxGrid {
   
    //#region Properties

    ControllerUrl = "LabelConfigurationItemFilter";

    //#endregion

    //#region Public Methods

    ItemCompleteCheck(item: any): JQueryPromise<boolean> {
        return $.Deferred().resolve(true).promise();
    }
    
    SearchType(): string {
        return "LabelConfigurationItemFilter";
    } 

    /**
     * Overriden Set DataGrid Columns
     */
    GetAvailableColumns(): any[] {
        return [
            {
                "PropertyName": "LabelName",
                "Sort": 1,
                "HeaderText": "Label"
            }
        ];
    }

    /**
    * Overriden customFilter
    * @returns array of filters
    */
    CustomFilter(): Models.HashObject[] {
        return [
            { 
                'Key': 'ConfigurationItemId', 
                'Value': this.Parent.PrimaryKeyValue() 
            }
        ];
    }
    
    //#endregion    
}
export default LabelConfigurationItemFilter;